import type { VfConfig } from '#types/config/components/vf'

export default {
  fallbackVariants: {
    'secondary-inverse': 'tertiary-inverse'
  },
  sizes: ['extra-tiny', 'tiny', 'xs', 'sm', 'md'],
  variants: [
    'loyalty',
    'loyalty-inverse',
    'primary',
    'primary-inverse',
    'secondary',
    'tertiary',
    'tertiary-inverse',
    'themable',
    'themable-inverse',
    'transparent',
    'transparent-inverse',
    'transparent-pill'
  ]
} satisfies VfConfig['button']
